module.exports = __webpack_public_path__ + "static/media/file-video.b25c1be3.svg";